import axios from 'axios'
import AccountSelectDepartment from "./AccountSelectDepartment";

let resolvesCurrent = [];
let rejectsCurrent = [];

class AccountUser {
  static $data = {
    login: '',
    auth: false,
    user: '',
    userName: '',
    partner: '',
    partnerName: '',
    department: '',
    departmentName: '',
    type: '',
    selectDepartment: false,
    loadingCurrent: false,
    loadingLogout: false,
  };

  constructor() {

  }

  static logout() {
    return AccountUser.xhr_logout()
  }

  static xhr_logout() {
    return new Promise((resolve, reject) => {
      axios
        .post(`/tourclient/account/logout?_=${new Date().getTime()}`)
        .then(({data}) => {
          AccountUser.set({}).then(resolve);
        })
        .catch(err => {
          AccountUser.set({}).then(reject);
        })
    })
  }

  static current() {
    return new Promise((resolve, reject) => {
      resolvesCurrent.push(resolve);
      rejectsCurrent.push(reject);
      if (resolvesCurrent.length !== 1) return;
      AccountUser.$data.loadingCurrent = true;
      AccountUser
        .xhr_current()
        .then((data) => {
          resolvesCurrent.forEach(i => i(AccountUser));
          resolvesCurrent = [];
          rejectsCurrent = [];
          AccountUser.$data.loadingCurrent = false;
        })
        .catch(err => {
          rejectsCurrent.forEach(i => i(err));
          resolvesCurrent = [];
          rejectsCurrent = [];
          AccountUser.$data.loadingCurrent = false;
        })
    });
  }

  static xhr_current() {
    return new Promise((resolve, reject) => {
      axios
        .get('/tourclient/account/currentUser')
        .then(({data}) => {
          AccountUser.set(data).then(resolve);
        })
        .catch(err => {
          AccountUser.set({}).then(reject);
        })
    })
  }

  static set(data) {
    return new Promise((resolve) => {
      if (data && data.IsAuthenticated) {
        AccountUser.$data.login = data.Login;
        AccountUser.$data.auth = true;
        AccountUser.$data.user = data.MasterAgentUserId;
        AccountUser.$data.userName = data.FullName;
        AccountUser.$data.partner = data.PartnerId;
        AccountUser.$data.partnerName = data.PartnerName;
        AccountUser.$data.department = data.DepartmentId;
        AccountUser.$data.departmentName = data.Department;
        AccountUser.$data.type = data.UserType;
        if (data.NeedSelectDepartment) {
          AccountSelectDepartment
            .open(AccountUser.$data.department)
            .then(id => {
              AccountUser.$data.department = id;
              resolve();
            })
            .catch(err => {
              AccountUser.logout().then(resolve);
            });
          return;
        }
      } else {
        AccountUser.$data.login = '';
        AccountUser.$data.auth = false;
        AccountUser.$data.user = '';
        AccountUser.$data.userName = '';
        AccountUser.$data.partner = '';
        AccountUser.$data.partnerName = '';
        AccountUser.$data.department = '';
        AccountUser.$data.departmentName = '';
        AccountUser.$data.type = 0;
      }
      resolve();
    });
  }

  static get login() {
    return AccountUser.$data.login
  }

  static get auth() {
    return AccountUser.$data.auth
  }

  static get user() {
    return AccountUser.$data.user
  }

  static get userName() {
    return AccountUser.$data.userName
  }

  static get partner() {
    return AccountUser.$data.partner
  }

  static get partnerName() {
    return AccountUser.$data.partnerName
  }

  static get department() {
    return AccountUser.$data.department
  }

  static get departmentName() {
    return AccountUser.$data.departmentName
  }

  static get type() {
    return AccountUser.$data.type
  }
}

export default AccountUser;